import { useEffect, useRef, useState } from 'react'
import HelperDate, { dateFormat } from 'utils/helper-date'

const useMinute = () => {
	
	const timeRef = useRef();
	
	const getDatetime = () => {
		return HelperDate.date().format( dateFormat.DATE_TIME )
	}
	
	const [ date, setDate ] = useState( getDatetime() )
	
	const create = () => {
		const now = HelperDate.date();
		const nextMin = HelperDate.date().add( 1, 'minute' ).startOf('minute');
		const secondsTillNewMinute = nextMin.diff( now, 'second' );
		
		timeRef.current = setTimeout(() => {
			setDate( getDatetime() )
		}, 1000 * secondsTillNewMinute )
	}
	
	useEffect( () => {
		return create();
	}, [ date ] );
	
	useEffect(() => {
		create();
		
		return () => {
			clearInterval( timeRef.current )
		}
	}, [])
	
	return date
}

export default useMinute
